import axios from './axios'
import config from '../config'

export default {
    search(params) {
        return axios({
            url: config.backendUrl + '/common/news-section/search',
            method: 'GET',
            params
        })
    },
    parseSortExpr(sortExpr){
        return sortExpr.split(/,/g).map(item => {
            const arr = item.trim().split(/\s+/)
            return arr[0] + ',' + (arr.length>1?arr[1].toUpperCase():'ASC')
        })
    }
}
